import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useTrackView } from '#src/app/shared/hooks/tracking';

export function useTrackPageView(): void {
	const ov = useQueryParamValue('ov');
	useTrackView('about_view', { open_video: ov === 'true' });
}
